module.exports = { id: "triangle-right", url: "/build/app/img/symbols.svg#triangle-right", viewBox: "", toString: function() { return this.url; } };